// date.js
// 用于格式化时间
Date.prototype.Format = function(fmt) {
  var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
  return fmt
}

export function formatTimeToStr(times, pattern) {
  var d = new Date(times).Format("yyyy年MM月dd日")
  if (pattern) {
    d = new Date(times).Format(pattern)
  }
  return d.toLocaleString()
}